const formatArrayOfObject = (arr) => arr.filter((item) => !(Array.isArray(item)));

export default formatArrayOfObject;
